// NYC NEC Standard Electrical & Security Symbols
// Each symbol is an SVG component drawn to scale (40x40 viewBox)
import React from 'react';

const stroke = '#0a0a0a';
const sw = 1.6;

// ============ ELECTRICAL (HIGH VOLTAGE) ============
const Duplex = () => (
  <g><circle cx="20" cy="20" r="13" fill="#fff" stroke={stroke} strokeWidth={sw}/>
  <line x1="20" y1="7" x2="20" y2="33" stroke={stroke} strokeWidth={sw}/>
  <text x="20" y="23" textAnchor="middle" fontSize="9" fontWeight="700" fill={stroke}>R</text></g>
);
const GFCI = () => (
  <g><circle cx="20" cy="20" r="13" fill="#fff" stroke={stroke} strokeWidth={sw}/>
  <text x="20" y="24" textAnchor="middle" fontSize="8" fontWeight="700" fill={stroke}>GFCI</text></g>
);
const Outlet240 = () => (
  <g><circle cx="20" cy="20" r="13" fill="#fff" stroke={stroke} strokeWidth={sw}/>
  <text x="20" y="24" textAnchor="middle" fontSize="8" fontWeight="700" fill={stroke}>240V</text></g>
);
const FloorOutlet = () => (
  <g><circle cx="20" cy="20" r="13" fill="#fff" stroke={stroke} strokeWidth={sw}/>
  <rect x="14" y="14" width="12" height="12" fill="#000"/></g>
);
const Switch = () => (
  <g><line x1="6" y1="20" x2="34" y2="20" stroke={stroke} strokeWidth={sw}/>
  <text x="20" y="16" textAnchor="middle" fontSize="11" fontWeight="700" fill={stroke}>S</text></g>
);
const Switch3 = () => (
  <g><line x1="6" y1="20" x2="34" y2="20" stroke={stroke} strokeWidth={sw}/>
  <text x="20" y="16" textAnchor="middle" fontSize="11" fontWeight="700" fill={stroke}>S₃</text></g>
);
const Switch4 = () => (
  <g><line x1="6" y1="20" x2="34" y2="20" stroke={stroke} strokeWidth={sw}/>
  <text x="20" y="16" textAnchor="middle" fontSize="11" fontWeight="700" fill={stroke}>S₄</text></g>
);
const Dimmer = () => (
  <g><line x1="6" y1="20" x2="34" y2="20" stroke={stroke} strokeWidth={sw}/>
  <text x="20" y="16" textAnchor="middle" fontSize="10" fontWeight="700" fill={stroke}>S_D</text></g>
);
const Panel = () => (
  <g><rect x="6" y="6" width="28" height="28" fill="#fff" stroke={stroke} strokeWidth={sw}/>
  <text x="20" y="25" textAnchor="middle" fontSize="13" fontWeight="700" fill={stroke}>P</text></g>
);
const SubPanel = () => (
  <g><rect x="6" y="6" width="28" height="28" fill="#fff" stroke={stroke} strokeWidth={sw}/>
  <text x="20" y="25" textAnchor="middle" fontSize="11" fontWeight="700" fill={stroke}>SP</text></g>
);
const JunctionBox = () => (
  <g><rect x="10" y="10" width="20" height="20" fill="#fff" stroke={stroke} strokeWidth={sw}/>
  <text x="20" y="24" textAnchor="middle" fontSize="11" fontWeight="700" fill={stroke}>J</text></g>
);
const Light = () => (
  <g><circle cx="20" cy="20" r="11" fill="#fff" stroke={stroke} strokeWidth={sw}/>
  <line x1="12" y1="12" x2="28" y2="28" stroke={stroke} strokeWidth={sw}/>
  <line x1="28" y1="12" x2="12" y2="28" stroke={stroke} strokeWidth={sw}/></g>
);
const Recessed = () => (
  <g><circle cx="20" cy="20" r="11" fill="#fff" stroke={stroke} strokeWidth={sw}/>
  <circle cx="20" cy="20" r="4" fill={stroke}/></g>
);
const WallLight = () => (
  <g><circle cx="20" cy="20" r="9" fill="#fff" stroke={stroke} strokeWidth={sw}/>
  <line x1="20" y1="11" x2="20" y2="29" stroke={stroke} strokeWidth={sw}/>
  <line x1="11" y1="20" x2="29" y2="20" stroke={stroke} strokeWidth={sw}/>
  <text x="32" y="14" fontSize="8" fontWeight="700" fill={stroke}>W</text></g>
);
const CeilingFan = () => (
  <g><circle cx="20" cy="20" r="13" fill="#fff" stroke={stroke} strokeWidth={sw}/>
  <line x1="20" y1="8" x2="20" y2="32" stroke={stroke} strokeWidth={sw}/>
  <line x1="8" y1="20" x2="32" y2="20" stroke={stroke} strokeWidth={sw}/>
  <line x1="11" y1="11" x2="29" y2="29" stroke={stroke} strokeWidth={sw}/>
  <line x1="29" y1="11" x2="11" y2="29" stroke={stroke} strokeWidth={sw}/></g>
);
const Chandelier = () => (
  <g><circle cx="20" cy="20" r="6" fill={stroke}/>
  <circle cx="10" cy="26" r="3" fill="#fff" stroke={stroke} strokeWidth={sw}/>
  <circle cx="30" cy="26" r="3" fill="#fff" stroke={stroke} strokeWidth={sw}/>
  <circle cx="20" cy="30" r="3" fill="#fff" stroke={stroke} strokeWidth={sw}/></g>
);
const Exit = () => (
  <g><rect x="4" y="14" width="32" height="12" fill="#fff" stroke={stroke} strokeWidth={sw}/>
  <text x="20" y="23" textAnchor="middle" fontSize="9" fontWeight="800" fill={stroke}>EXIT</text></g>
);
const EmergencyLight = () => (
  <g><rect x="6" y="12" width="28" height="16" fill="#fff" stroke={stroke} strokeWidth={sw}/>
  <circle cx="13" cy="20" r="3" fill={stroke}/><circle cx="27" cy="20" r="3" fill={stroke}/></g>
);
const SmokeDet = () => (
  <g><circle cx="20" cy="20" r="13" fill="#fff" stroke={stroke} strokeWidth={sw}/>
  <text x="20" y="24" textAnchor="middle" fontSize="9" fontWeight="700" fill={stroke}>SD</text></g>
);
const COdet = () => (
  <g><circle cx="20" cy="20" r="13" fill="#fff" stroke={stroke} strokeWidth={sw}/>
  <text x="20" y="24" textAnchor="middle" fontSize="9" fontWeight="700" fill={stroke}>CO</text></g>
);
const HeatDet = () => (
  <g><rect x="6" y="6" width="28" height="28" rx="4" fill="#fff" stroke={stroke} strokeWidth={sw}/>
  <text x="20" y="24" textAnchor="middle" fontSize="9" fontWeight="700" fill={stroke}>H</text></g>
);
const EVCharger = () => (
  <g><rect x="8" y="6" width="24" height="28" rx="2" fill="#fff" stroke={stroke} strokeWidth={sw}/>
  <text x="20" y="22" textAnchor="middle" fontSize="11" fontWeight="800" fill={stroke}>EV</text>
  <line x1="14" y1="26" x2="26" y2="26" stroke={stroke} strokeWidth={sw}/></g>
);
const Thermostat = () => (
  <g><circle cx="20" cy="20" r="13" fill="#fff" stroke={stroke} strokeWidth={sw}/>
  <text x="20" y="24" textAnchor="middle" fontSize="11" fontWeight="700" fill={stroke}>T</text></g>
);
const PullChain = () => (
  <g><circle cx="20" cy="14" r="6" fill="#fff" stroke={stroke} strokeWidth={sw}/>
  <line x1="20" y1="20" x2="20" y2="34" stroke={stroke} strokeWidth={sw}/>
  <line x1="17" y1="34" x2="23" y2="34" stroke={stroke} strokeWidth={sw}/></g>
);

// ============ LOW VOLTAGE / DATA ============
const DataJack = () => (
  <g><polygon points="20,8 32,30 8,30" fill="#fff" stroke={stroke} strokeWidth={sw}/>
  <text x="20" y="26" textAnchor="middle" fontSize="9" fontWeight="700" fill={stroke}>D</text></g>
);
const PhoneJack = () => (
  <g><polygon points="20,8 32,30 8,30" fill="#fff" stroke={stroke} strokeWidth={sw}/>
  <text x="20" y="26" textAnchor="middle" fontSize="9" fontWeight="700" fill={stroke}>P</text></g>
);
const TVJack = () => (
  <g><polygon points="20,8 32,30 8,30" fill="#fff" stroke={stroke} strokeWidth={sw}/>
  <text x="20" y="26" textAnchor="middle" fontSize="8" fontWeight="700" fill={stroke}>TV</text></g>
);
const FiberJack = () => (
  <g><polygon points="20,8 32,30 8,30" fill="#fff" stroke={stroke} strokeWidth={sw}/>
  <text x="20" y="26" textAnchor="middle" fontSize="8" fontWeight="700" fill={stroke}>FO</text></g>
);

// ============ CCTV / SECURITY ============
const Camera = () => (
  <g><rect x="6" y="14" width="18" height="12" fill="#fff" stroke={stroke} strokeWidth={sw}/>
  <polygon points="24,16 34,12 34,28 24,24" fill="#fff" stroke={stroke} strokeWidth={sw}/>
  <circle cx="14" cy="20" r="3" fill={stroke}/></g>
);
const DomeCamera = () => (
  <g><path d="M 8 22 A 12 12 0 0 1 32 22 L 32 28 L 8 28 Z" fill="#fff" stroke={stroke} strokeWidth={sw}/>
  <circle cx="20" cy="22" r="4" fill={stroke}/></g>
);
const PTZCamera = () => (
  <g><circle cx="20" cy="20" r="12" fill="#fff" stroke={stroke} strokeWidth={sw}/>
  <circle cx="20" cy="20" r="5" fill={stroke}/>
  <text x="20" y="36" textAnchor="middle" fontSize="7" fontWeight="700" fill={stroke}>PTZ</text></g>
);
const LPRCamera = () => (
  <g><rect x="6" y="12" width="28" height="16" rx="2" fill="#fff" stroke={stroke} strokeWidth={sw}/>
  <text x="20" y="24" textAnchor="middle" fontSize="9" fontWeight="700" fill={stroke}>LPR</text></g>
);
const DVR = () => (
  <g><rect x="4" y="10" width="32" height="20" fill="#fff" stroke={stroke} strokeWidth={sw}/>
  <text x="20" y="24" textAnchor="middle" fontSize="9" fontWeight="700" fill={stroke}>NVR</text></g>
);
const Motion = () => (
  <g><polygon points="8,30 32,30 26,10 14,10" fill="#fff" stroke={stroke} strokeWidth={sw}/>
  <text x="20" y="25" textAnchor="middle" fontSize="9" fontWeight="700" fill={stroke}>M</text></g>
);
const Glassbreak = () => (
  <g><rect x="6" y="6" width="28" height="28" rx="3" fill="#fff" stroke={stroke} strokeWidth={sw}/>
  <text x="20" y="24" textAnchor="middle" fontSize="9" fontWeight="700" fill={stroke}>GB</text></g>
);
const DoorContact = () => (
  <g><rect x="6" y="14" width="12" height="12" fill="#fff" stroke={stroke} strokeWidth={sw}/>
  <rect x="22" y="14" width="12" height="12" fill="#fff" stroke={stroke} strokeWidth={sw}/></g>
);
const Siren = () => (
  <g><polygon points="20,6 32,20 32,30 8,30 8,20" fill="#fff" stroke={stroke} strokeWidth={sw}/>
  <text x="20" y="25" textAnchor="middle" fontSize="9" fontWeight="700" fill={stroke}>S</text></g>
);
const AlarmPanel = () => (
  <g><rect x="6" y="6" width="28" height="28" fill="#fff" stroke={stroke} strokeWidth={sw}/>
  <text x="20" y="25" textAnchor="middle" fontSize="9" fontWeight="700" fill={stroke}>AP</text></g>
);

// ============ NETWORK ============
const WifiAP = () => (
  <g><circle cx="20" cy="22" r="4" fill={stroke}/>
  <path d="M 12 18 Q 20 10 28 18" fill="none" stroke={stroke} strokeWidth={sw}/>
  <path d="M 8 15 Q 20 3 32 15" fill="none" stroke={stroke} strokeWidth={sw}/></g>
);
const ServerRack = () => (
  <g><rect x="8" y="6" width="24" height="28" fill="#fff" stroke={stroke} strokeWidth={sw}/>
  <line x1="8" y1="12" x2="32" y2="12" stroke={stroke} strokeWidth={sw}/>
  <line x1="8" y1="18" x2="32" y2="18" stroke={stroke} strokeWidth={sw}/>
  <line x1="8" y1="24" x2="32" y2="24" stroke={stroke} strokeWidth={sw}/>
  <line x1="8" y1="30" x2="32" y2="30" stroke={stroke} strokeWidth={sw}/></g>
);
const PatchPanel = () => (
  <g><rect x="4" y="14" width="32" height="12" fill="#fff" stroke={stroke} strokeWidth={sw}/>
  <text x="20" y="23" textAnchor="middle" fontSize="8" fontWeight="700" fill={stroke}>PATCH</text></g>
);
const NetSwitch = () => (
  <g><rect x="4" y="16" width="32" height="10" fill="#fff" stroke={stroke} strokeWidth={sw}/>
  <line x1="8" y1="22" x2="10" y2="22" stroke={stroke} strokeWidth={sw}/>
  <line x1="13" y1="22" x2="15" y2="22" stroke={stroke} strokeWidth={sw}/>
  <line x1="18" y1="22" x2="20" y2="22" stroke={stroke} strokeWidth={sw}/>
  <line x1="23" y1="22" x2="25" y2="22" stroke={stroke} strokeWidth={sw}/>
  <line x1="28" y1="22" x2="30" y2="22" stroke={stroke} strokeWidth={sw}/></g>
);

// ============ ACCESS CONTROL / INTERCOM ============
const CardReader = () => (
  <g><rect x="10" y="6" width="20" height="28" rx="2" fill="#fff" stroke={stroke} strokeWidth={sw}/>
  <rect x="14" y="14" width="12" height="3" fill={stroke}/>
  <text x="20" y="28" textAnchor="middle" fontSize="9" fontWeight="700" fill={stroke}>CR</text></g>
);
const Biometric = () => (
  <g><rect x="10" y="6" width="20" height="28" rx="2" fill="#fff" stroke={stroke} strokeWidth={sw}/>
  <text x="20" y="22" textAnchor="middle" fontSize="11" fontWeight="700" fill={stroke}>FP</text></g>
);
const Keypad = () => (
  <g><rect x="8" y="6" width="24" height="28" rx="2" fill="#fff" stroke={stroke} strokeWidth={sw}/>
  <circle cx="14" cy="14" r="1.5" fill={stroke}/><circle cx="20" cy="14" r="1.5" fill={stroke}/><circle cx="26" cy="14" r="1.5" fill={stroke}/>
  <circle cx="14" cy="22" r="1.5" fill={stroke}/><circle cx="20" cy="22" r="1.5" fill={stroke}/><circle cx="26" cy="22" r="1.5" fill={stroke}/></g>
);
const ElectricStrike = () => (
  <g><rect x="6" y="14" width="28" height="12" fill="#fff" stroke={stroke} strokeWidth={sw}/>
  <text x="20" y="23" textAnchor="middle" fontSize="9" fontWeight="700" fill={stroke}>STRK</text></g>
);
const MagLock = () => (
  <g><rect x="6" y="14" width="28" height="12" fill="#fff" stroke={stroke} strokeWidth={sw}/>
  <text x="20" y="23" textAnchor="middle" fontSize="9" fontWeight="700" fill={stroke}>MAG</text></g>
);
const Intercom = () => (
  <g><rect x="10" y="6" width="20" height="28" rx="2" fill="#fff" stroke={stroke} strokeWidth={sw}/>
  <circle cx="20" cy="14" r="3" fill={stroke}/>
  <rect x="14" y="22" width="12" height="6" fill={stroke}/></g>
);
const VideoIntercom = () => (
  <g><rect x="6" y="6" width="28" height="28" rx="2" fill="#fff" stroke={stroke} strokeWidth={sw}/>
  <circle cx="20" cy="14" r="3" fill={stroke}/>
  <text x="20" y="27" textAnchor="middle" fontSize="8" fontWeight="700" fill={stroke}>VID</text></g>
);
const DoorStation = () => (
  <g><rect x="10" y="4" width="20" height="32" rx="2" fill="#fff" stroke={stroke} strokeWidth={sw}/>
  <circle cx="20" cy="12" r="3" fill={stroke}/>
  <rect x="14" y="20" width="12" height="4" fill={stroke}/>
  <rect x="14" y="26" width="12" height="4" fill={stroke}/></g>
);
const LobbyPanel = () => (
  <g><rect x="4" y="4" width="32" height="32" rx="2" fill="#fff" stroke={stroke} strokeWidth={sw}/>
  <line x1="4" y1="14" x2="36" y2="14" stroke={stroke} strokeWidth={sw}/>
  <line x1="4" y1="22" x2="36" y2="22" stroke={stroke} strokeWidth={sw}/>
  <line x1="4" y1="30" x2="36" y2="30" stroke={stroke} strokeWidth={sw}/>
  <text x="20" y="11" textAnchor="middle" fontSize="6" fontWeight="700" fill={stroke}>LOBBY</text></g>
);
const PagingHorn = () => (
  <g><polygon points="6,16 18,12 18,28 6,24" fill="#fff" stroke={stroke} strokeWidth={sw}/>
  <polygon points="18,12 32,6 32,34 18,28" fill="#fff" stroke={stroke} strokeWidth={sw}/>
  <text x="25" y="22" textAnchor="middle" fontSize="6" fontWeight="700" fill={stroke}>PA</text></g>
);
const PushButton = () => (
  <g><circle cx="20" cy="20" r="12" fill="#fff" stroke={stroke} strokeWidth={sw}/>
  <circle cx="20" cy="20" r="5" fill={stroke}/></g>
);

// ============ GENERATOR ============
const Generator = () => (
  <g><rect x="4" y="10" width="32" height="20" rx="2" fill="#fff" stroke={stroke} strokeWidth={sw}/>
  <text x="20" y="24" textAnchor="middle" fontSize="10" fontWeight="700" fill={stroke}>GEN</text></g>
);
const TransferSwitch = () => (
  <g><rect x="6" y="6" width="28" height="28" fill="#fff" stroke={stroke} strokeWidth={sw}/>
  <text x="20" y="19" textAnchor="middle" fontSize="9" fontWeight="700" fill={stroke}>ATS</text>
  <line x1="10" y1="24" x2="30" y2="24" stroke={stroke} strokeWidth={sw}/></g>
);
const Battery = () => (
  <g><rect x="6" y="14" width="26" height="12" fill="#fff" stroke={stroke} strokeWidth={sw}/>
  <rect x="32" y="17" width="2" height="6" fill={stroke}/>
  <text x="19" y="23" textAnchor="middle" fontSize="9" fontWeight="700" fill={stroke}>BATT</text></g>
);
const PortableGen = () => (
  <g><rect x="4" y="14" width="32" height="18" rx="3" fill="#fff" stroke={stroke} strokeWidth={sw}/>
  <circle cx="11" cy="32" r="3" fill="#fff" stroke={stroke} strokeWidth={sw}/>
  <circle cx="29" cy="32" r="3" fill="#fff" stroke={stroke} strokeWidth={sw}/>
  <text x="20" y="25" textAnchor="middle" fontSize="8" fontWeight="700" fill={stroke}>GEN</text></g>
);
const FuelTank = () => (
  <g><rect x="6" y="8" width="28" height="24" rx="6" fill="#fff" stroke={stroke} strokeWidth={sw}/>
  <text x="20" y="24" textAnchor="middle" fontSize="11" fontWeight="700" fill={stroke}>FUEL</text></g>
);
const UPS = () => (
  <g><rect x="6" y="6" width="28" height="28" rx="2" fill="#fff" stroke={stroke} strokeWidth={sw}/>
  <text x="20" y="24" textAnchor="middle" fontSize="11" fontWeight="700" fill={stroke}>UPS</text></g>
);
const SurgeProtector = () => (
  <g><rect x="4" y="12" width="32" height="16" fill="#fff" stroke={stroke} strokeWidth={sw}/>
  <polyline points="8,20 14,16 20,24 26,16 32,20" fill="none" stroke={stroke} strokeWidth={sw}/></g>
);

export const SYMBOL_LIBRARY = {
  // Electrical
  duplex: { name: 'Duplex Outlet', category: 'electrical', desc: 'Standard 120V duplex receptacle', Component: Duplex, price: 175, key: 'outlet_installation' },
  gfci: { name: 'GFCI Outlet', category: 'electrical', desc: 'Ground Fault Circuit Interrupter outlet', Component: GFCI, price: 225, key: 'gfci_outlet' },
  outlet240: { name: '240V Outlet', category: 'electrical', desc: '240V dedicated outlet', Component: Outlet240, price: 395, key: 'dedicated_circuit' },
  floor_outlet: { name: 'Floor Outlet', category: 'electrical', desc: 'Floor-mounted outlet', Component: FloorOutlet, price: 295, key: 'outlet_installation' },
  switch: { name: 'Switch (Single Pole)', category: 'electrical', desc: 'Single pole light switch', Component: Switch, price: 150, key: 'switch_installation' },
  switch3: { name: '3-Way Switch', category: 'electrical', desc: 'Three-way switch', Component: Switch3, price: 195, key: 'switch_installation' },
  switch4: { name: '4-Way Switch', category: 'electrical', desc: 'Four-way switch', Component: Switch4, price: 225, key: 'switch_installation' },
  dimmer: { name: 'Dimmer Switch', category: 'electrical', desc: 'Dimmer switch', Component: Dimmer, price: 195, key: 'dimmer_switch' },
  panel: { name: 'Main Panel', category: 'electrical', desc: 'Electrical service panel', Component: Panel, price: 2950, key: 'panel_upgrade_200a' },
  subpanel: { name: 'Sub Panel', category: 'electrical', desc: 'Electrical sub panel', Component: SubPanel, price: 1450, key: 'panel_upgrade_100a' },
  junction: { name: 'Junction Box', category: 'electrical', desc: 'Electrical junction box', Component: JunctionBox, price: 95, key: 'outlet_repair' },
  light: { name: 'Ceiling Light', category: 'electrical', desc: 'Ceiling light fixture', Component: Light, price: 175, key: 'light_fixture' },
  recessed: { name: 'Recessed Light', category: 'electrical', desc: 'Recessed (can) light', Component: Recessed, price: 225, key: 'recessed_lighting' },
  wall_light: { name: 'Wall Sconce', category: 'electrical', desc: 'Wall-mounted light', Component: WallLight, price: 195, key: 'light_fixture' },
  ceiling_fan: { name: 'Ceiling Fan', category: 'electrical', desc: 'Ceiling fan with light', Component: CeilingFan, price: 295, key: 'ceiling_fan' },
  chandelier: { name: 'Chandelier', category: 'electrical', desc: 'Chandelier fixture', Component: Chandelier, price: 395, key: 'chandelier' },
  exit_sign: { name: 'Exit Sign', category: 'electrical', desc: 'Emergency exit sign', Component: Exit, price: 275, key: 'exit_sign' },
  emergency_light: { name: 'Emergency Light', category: 'electrical', desc: 'Battery-backup emergency light', Component: EmergencyLight, price: 350, key: 'emergency_lighting' },
  smoke_det: { name: 'Smoke Detector', category: 'electrical', desc: 'Hardwired smoke detector', Component: SmokeDet, price: 125, key: 'smoke_detector' },
  co_det: { name: 'CO Detector', category: 'electrical', desc: 'Carbon monoxide detector', Component: COdet, price: 145, key: 'carbon_monoxide' },
  heat_det: { name: 'Heat Detector', category: 'electrical', desc: 'Heat detector', Component: HeatDet, price: 145, key: 'smoke_detector' },
  ev_charger: { name: 'EV Charger', category: 'electrical', desc: 'Level 2 EV charger', Component: EVCharger, price: 1250, key: 'ev_charger_level2' },
  thermostat: { name: 'Thermostat', category: 'electrical', desc: 'Smart thermostat', Component: Thermostat, price: 275, key: 'smart_home_hub' },
  pullchain: { name: 'Pull Chain Light', category: 'electrical', desc: 'Pull chain light fixture', Component: PullChain, price: 125, key: 'light_fixture' },
  // Low Voltage / Data
  data_jack: { name: 'Data Outlet', category: 'networking', desc: 'CAT6 ethernet data jack', Component: DataJack, price: 185, key: 'cat6_drop' },
  phone_jack: { name: 'Phone Jack', category: 'networking', desc: 'Telephone jack', Component: PhoneJack, price: 125, key: 'cat6_drop' },
  tv_jack: { name: 'TV/Coax Jack', category: 'networking', desc: 'Coaxial TV outlet', Component: TVJack, price: 145, key: 'cat6_drop' },
  fiber_jack: { name: 'Fiber Outlet', category: 'networking', desc: 'Fiber optic outlet', Component: FiberJack, price: 495, key: 'fiber_optic' },
  wifi_ap: { name: 'WiFi Access Point', category: 'networking', desc: 'Wireless access point', Component: WifiAP, price: 295, key: 'wifi_access_point' },
  server_rack: { name: 'Server Rack', category: 'networking', desc: 'Network server rack', Component: ServerRack, price: 1250, key: 'server_rack' },
  patch_panel: { name: 'Patch Panel', category: 'networking', desc: 'Network patch panel', Component: PatchPanel, price: 450, key: 'patch_panel' },
  net_switch: { name: 'Network Switch', category: 'networking', desc: 'Managed network switch', Component: NetSwitch, price: 395, key: 'network_switch' },
  // CCTV / Security
  camera: { name: 'CCTV Bullet Camera', category: 'cctv', desc: 'Bullet security camera', Component: Camera, price: 395, key: 'camera_outdoor' },
  dome_camera: { name: 'Dome Camera', category: 'cctv', desc: 'Dome security camera', Component: DomeCamera, price: 425, key: 'camera_dome' },
  ptz_camera: { name: 'PTZ Camera', category: 'cctv', desc: 'Pan-Tilt-Zoom camera', Component: PTZCamera, price: 1250, key: 'camera_ptz_commercial' },
  lpr_camera: { name: 'License Plate Camera', category: 'cctv', desc: 'License plate reader camera', Component: LPRCamera, price: 895, key: 'camera_license_plate' },
  nvr: { name: 'NVR / DVR', category: 'cctv', desc: 'Network/Digital Video Recorder', Component: DVR, price: 1250, key: 'nvr_16ch' },
  motion: { name: 'Motion Sensor', category: 'cctv', desc: 'PIR motion detector', Component: Motion, price: 195, key: 'doorbell_camera' },
  glassbreak: { name: 'Glass Break Sensor', category: 'cctv', desc: 'Glass break detector', Component: Glassbreak, price: 225, key: 'doorbell_camera' },
  door_contact: { name: 'Door/Window Contact', category: 'cctv', desc: 'Magnetic contact sensor', Component: DoorContact, price: 95, key: 'doorbell_camera' },
  siren: { name: 'Siren', category: 'cctv', desc: 'Outdoor alarm siren', Component: Siren, price: 295, key: 'doorbell_camera' },
  alarm_panel: { name: 'Alarm Panel', category: 'cctv', desc: 'Alarm control panel', Component: AlarmPanel, price: 495, key: 'doorbell_camera' },
  // Access Control / Intercom
  card_reader: { name: 'Card Reader', category: 'access_control', desc: 'Proximity card reader', Component: CardReader, price: 595, key: 'card_reader' },
  biometric: { name: 'Biometric Reader', category: 'access_control', desc: 'Fingerprint biometric reader', Component: Biometric, price: 1250, key: 'biometric_reader' },
  keypad: { name: 'Keypad', category: 'access_control', desc: 'Access keypad', Component: Keypad, price: 295, key: 'keypad_lock' },
  electric_strike: { name: 'Electric Strike', category: 'access_control', desc: 'Electric door strike', Component: ElectricStrike, price: 595, key: 'electric_strike_commercial' },
  mag_lock: { name: 'Mag Lock', category: 'access_control', desc: 'Magnetic lock 1200lb', Component: MagLock, price: 695, key: 'magnetic_lock_1200lb' },
  intercom: { name: 'Audio Intercom', category: 'intercom', desc: 'Audio intercom station', Component: Intercom, price: 295, key: 'audio_intercom' },
  video_intercom: { name: 'Video Intercom', category: 'intercom', desc: 'Video intercom unit', Component: VideoIntercom, price: 495, key: 'video_intercom_unit' },
  door_station: { name: 'Door Station', category: 'intercom', desc: 'Entrance door station', Component: DoorStation, price: 395, key: 'door_station' },
  lobby_panel: { name: 'Lobby Panel', category: 'intercom', desc: 'Lobby directory panel', Component: LobbyPanel, price: 2450, key: 'lobby_panel' },
  paging_horn: { name: 'Paging Horn', category: 'intercom', desc: 'PA / paging speaker horn', Component: PagingHorn, price: 295, key: 'pa_system' },
  push_button: { name: 'Push Button (REX)', category: 'access_control', desc: 'Request-to-exit button', Component: PushButton, price: 125, key: 'electric_strike' },
  // Generator
  generator: { name: 'Standby Generator', category: 'generator', desc: 'Standby generator', Component: Generator, price: 9500, key: 'standby_22kw' },
  portable_generator: { name: 'Portable Generator', category: 'generator', desc: 'Portable generator unit', Component: PortableGen, price: 1850, key: 'portable_hookup' },
  transfer_switch: { name: 'Auto Transfer Switch', category: 'generator', desc: 'Automatic transfer switch', Component: TransferSwitch, price: 1495, key: 'transfer_switch_auto' },
  fuel_tank: { name: 'Fuel Tank', category: 'generator', desc: 'Generator fuel tank', Component: FuelTank, price: 1250, key: 'standby_12kw' },
  battery: { name: 'Battery Backup', category: 'generator', desc: 'Battery backup system', Component: Battery, price: 2950, key: 'battery_backup' },
  ups: { name: 'UPS System', category: 'generator', desc: 'Uninterruptible power supply', Component: UPS, price: 3500, key: 'ups_system' },
  surge_protector: { name: 'Surge Protector', category: 'generator', desc: 'Whole-house surge protector', Component: SurgeProtector, price: 495, key: 'whole_house_surge' },
};

export const SymbolSVG = ({ symbolKey, size = 40 }) => {
  const def = SYMBOL_LIBRARY[symbolKey];
  if (!def) return null;
  const C = def.Component;
  return (
    <svg viewBox="0 0 40 40" width={size} height={size}>
      <C />
    </svg>
  );
};

export const SYMBOL_CATEGORIES = {
  electrical: { name: 'Electrical (High Voltage)', color: 'amber' },
  networking: { name: 'Low Voltage / Data', color: 'blue' },
  cctv: { name: 'CCTV & Security', color: 'red' },
  access_control: { name: 'Access Control', color: 'purple' },
  intercom: { name: 'Intercom', color: 'green' },
  generator: { name: 'Generator / Power', color: 'orange' },
};
